export default {
    container : '<div class="uwr-slider-container">'
        + '{{#showBoundaries}}<div class="uwr-slider-indicator-value uwr-slider-indicator-value-min">'
        + '{{minValue}}</div>{{/showBoundaries}}'
        + '<div class="uwr-slider-indicator-container" style="width:{{sliderWidth}}px">'
        + '</div>'
        + '{{#showBoundaries}}<div class="uwr-slider-indicator-value uwr-slider-indicator-value-max">'
        + '{{maxValue}}</div>{{/showBoundaries}}'
        + '</div>',
    indicator: '<div class="uwr-slider-indicator"></div>',
    label: '<span class="uwr-slider-label"></span>',
    marker: '<div class="uwr-slider-value"></div>',
    scale: '<div class="uwr-slider-scale"></div>',
    thumb: '<div class="uwr-slider-thumb"></div>'
};


//////////////////
// WEBPACK FOOTER
// ./widgets/Slider/js/sliderView.js
// module id = 95
// module chunks = main